import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { CustomColumnField, MeasureField, MetricField } from "../../../../../../../../../api/types/svTypes.ts";
import BlankZeroMenuItem from "../../../common/fields/field-options/BlankZeroMenuItem.tsx";
import OtherOptionsWrapper from "../../../common/fields/field-options/OtherOptionsWrapper.tsx";
import ReverseSignMenuItem from "../../../common/fields/field-options/ReverseSignMenuItem.tsx";
import SuppressBlankValues from "../../../common/fields/field-options/SuppressBlankValues.tsx";
import { isMeasureMeta } from "../../../common/utilities/metaUtils.ts";
import PivotFieldMenuItem from "./menuItems/PivotFieldMenuItem.tsx";

interface Props {
  field: MeasureField | MetricField | CustomColumnField;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
}
const ValuesOtherOptions = ({ field, saveChanges, readonly }: Props) => {
  const isScalarMeasure = isMeasureMeta(field.meta) && field.meta.capabilities.isScalar;

  return (
    <OtherOptionsWrapper>
      {!isScalarMeasure && (
        <>
          <BlankZeroMenuItem field={field} saveChanges={saveChanges} readonly={readonly} />
          <ReverseSignMenuItem field={field} saveChanges={saveChanges} readonly={readonly} />
        </>
      )}
      <PivotFieldMenuItem field={field} saveChanges={saveChanges} readonly={readonly} />
      <SuppressBlankValues
        field={field}
        onChanged={saveChanges}
        showExcludeZeroValues={field.config.hideBlankValues === true}
        readonly={readonly}
      />
    </OtherOptionsWrapper>
  );
};

export default ValuesOtherOptions;
